import { render, staticRenderFns } from "./caigouxq.vue?vue&type=template&id=331605de&scoped=true&"
import script from "./caigouxq.vue?vue&type=script&lang=js&"
export * from "./caigouxq.vue?vue&type=script&lang=js&"
import style0 from "./caigouxq.vue?vue&type=style&index=0&id=331605de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331605de",
  null
  
)

export default component.exports